<div class="content dark">
	<div class="row">
		<div class="col-12">
			<div class="item-panel">
				<div class="heading">Engine Maintenance</div>
				<div class="content">
					<p>This asset has an available alternate engine configuration. When checked below, any future incoming files
						will have the engine CIs calculated using the alternate configuration.</p>
					<p>Changing this setting does not affect data that has already been imported.</p>
					<div class="form-group form-check">
						<label class="form-check-label">
							<input [(ngModel)]="asset.alt_engine" (ngModelChange)="UpdateAltEngine()" class="form-check-input"
								type="checkbox">
							Enable {{components.alt_engine_name}}
						</label>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>